import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {GLOBE__24} from '@homeaway/svg-defs';
import './PreferencePanel.less';

class PreferencePanel extends Component {
    static propTypes = {
        currency: PropTypes.object,
        currencyName: PropTypes.string,
        currencySymbol: PropTypes.string,
        countryCode: PropTypes.string,
        locale: PropTypes.string,
        languageName: PropTypes.string,
        renderCountryLanguageSelector: PropTypes.bool,
        renderCurrencySelector: PropTypes.bool,
        onClick: PropTypes.func
    }
    static defaultProps = {
        currency: {code: 'USD', symbol: 'US$', name: 'US Dollar'},
        currencyName: 'US Dollar',
        currencySymbol: '$',
        countryCode: 'USA',
        locale: 'en_US',
        languageName: 'English',
        renderCountryLanguageSelector: true,
        renderCurrencySelector: true,
        onClick: () => {}
    }
    constructor(props) {
        super(props);
    }

    render() {
        const {countryCode, locale, languageName, currency, languageSelectorOnly, renderCountryLanguageSelector, renderCurrencySelector, onClick} = this.props;
        let languageCode = locale.substr(0, 2).toUpperCase();
        return (
            <div className="globalization-selector-preference" onClick={onClick} onKeyPress={onClick} role="button" tabIndex="0">
                <div className="clearfix">
                    {renderCountryLanguageSelector &&
                    <div className="preference-item">
                        {!languageSelectorOnly &&
                        <div className="preference-item__country preference-item__language">
                            <i className={`flag-${countryCode} preference-item__flag`} aria-hidden="true"/>
                            <span className="preference-item__text">
                                <span className="visible-lg-inline">{languageName}</span>
                                <span className="hidden-lg">{languageCode}</span>
                            </span>
                        </div>}
                        {languageSelectorOnly &&
                        <div className="preference-item__language">
                            <SVGIcon className="globalization-selector-preference__svg" markup={GLOBE__24} inlineFlex/>
                            <span className="preference-item__text">
                                <span className="visible-lg-inline">{languageName}</span>
                                <span className="hidden-lg">{languageCode}</span>
                            </span>
                        </div>}
                    </div>
                    }
                    {renderCountryLanguageSelector && renderCurrencySelector &&
                    <div className="preference-item preference-item__separator" />
                    }
                    {renderCurrencySelector &&
                    <div className="preference-item">
                        <div className="visible-lg-inline">{`${currency.code } (${ currency.symbol })`}</div>
                        <div className="hidden-lg">{currency.symbol}</div>
                    </div>
                    }
                </div>
            </div>
        );
    }
}

export default PreferencePanel;
